import { Collapse, makeStyles } from "@material-ui/core";

import { Alert } from "@material-ui/lab";
import React from "react";
import { get } from "lodash";
import { useFormState } from "react-final-form";
import { useTranslate } from "react-admin";
import useValidation from "./useValidation";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const ValidationBox = ({ ...props }) => {
  const classes = useStyles();
  const form = useFormState();
  const translate = useTranslate();
  const {
    planning: { completed, empty, exceeded, loaded },
    duration,
    min,
    max,
  } = useValidation(form);
  const visited =
    Object.keys(form.visited).filter(
      (field) => get(form.visited, field, false) === true
    ).length > 0;

  return (
    <Collapse in={!completed && visited}>
      <Alert
        severity="warning"
        color="warning"
        variant="filled"
        className={classes.root}
      >
        {translate(
          `resources.executive-project-work-packages.warning.${
            exceeded ? "exceeded" : "not_fully_planned"
          }`,
          {
            duration,
            months: empty.join(", "),
            min: min.format(translate("app.date_format.short")),
            max: max.format(translate("app.date_format.short")),
            loaded: loaded.length,
            empty: empty.length,
          }
        )}
      </Alert>
    </Collapse>
  );
};

export default ValidationBox;
